import config from '../../../config';
import { showErrorMsg } from '../ErrorMsg';
import queryString from 'query-string';

export const fetchDeal = slug =>
  $.ajax({
    url: `${config.localeApi}/deals/${slug}`,
    dataType: 'json',
  });

export const getDealMobileMenu = url => $.get(`${config.localeApi}/deals/${url}/menu`)
  .fail(({ responseJSON: { errors = '' } }) => {
    showErrorMsg(errors);
  });

export const getData = (url) => {
  const dealUrl = `${config.localeApi}/deals/${url}`;

  return $.get(dealUrl)
    .fail((resp) => {
      const { errors = null } = resp.responseJSON;
      if (errors) {
        const msg = Object.keys(errors)
          .map(key => (errors[key].join('')))
          .join('<br/>');
        toastr.warning(msg);
      }
    });
};

export const getDealsData = (url, tag, params = {}) => {
  const queryParams = queryString.stringify(params);

  return $.get(`${config.localeApi}/deals/${url}/tag/${tag}?${queryParams}`)
  .fail(({ responseJSON: { errors = '' } }) => {
    showErrorMsg(errors);
  })
};



// WEBPACK FOOTER //
// ./src/Common/Providers/DealApi.js